import axios from 'axios'
import '@/store' // 确保 setActivePinia 在此处生效
import { getActivePinia } from 'pinia'
import UserInfo from '@/store/userStore'
import { handleWeChatAuth } from '@/utils/wechat'

const WX_AUTH_FAIL_AT_KEY = '__wx_auth_fail_at__'
// 用 sessionStorage 做跨页跳转的防重入标志（内存变量在页面跳转后会重置）
const WX_REDIRECTING_KEY = '__wx_redirecting__'

const request = axios.create({
	// baseURL: '/api', //基础路径（配置跨域用）
	// baseURL: 'http://192.168.10.123:8082/', //基础路径
	baseURL: 'https://www.i-oranges.com/', //基础路径

	// "/hlUserS251219/"; //主地址
	// "http://192.168.10.123:8082/hlUserS251219/"; //本地地址

	timeout: 10000,
})

/**
 * 获取 md5OpenId
 * 优先从 Pinia store 获取，若 Pinia 未挂载则从 localStorage 降级读取
 */
function getMd5OpenId() {
	// 1. 优先 Pinia store
	try {
		if (getActivePinia()) {
			const userStore = UserInfo()
			if (userStore && userStore.md5OpenId) {
				return userStore.md5OpenId
			}
		}
	} catch (e) {
		// Pinia 未就绪，降级
	}

	// 2. 降级：从 localStorage 读（Pinia 持久化 key 为 'User'）
	try {
		const raw = localStorage.getItem('User')
		if (raw) {
			const parsed = JSON.parse(raw)
			if (parsed.md5OpenId) {
				return parsed.md5OpenId
			}
		}
	} catch (e) {
		// ignore
	}

	return ''
}

request.interceptors.request.use((config) => {
	const md5OpenId = getMd5OpenId();

	if (md5OpenId) {
		config.headers.Authorization = `Bearer ${md5OpenId}`
		console.log('[request] Authorization set:', `Bearer ${md5OpenId.substring(0, 6)}...`)
	} else {
		console.warn('[request] md5OpenId 为空，未设置 Authorization')
	}
	return config
})

// 防重入标志：用 sessionStorage，页面跳转后仍有效
let isHandling401 = false

request.interceptors.response.use(
	(response) => {
		return response.data
	},
	async (error) => {
		const status = error.response.status
		const isRedirecting = sessionStorage.getItem(WX_REDIRECTING_KEY)
		if (status === 401 && !isHandling401 && !isRedirecting) {
			isHandling401 = true
			// 标记"正在跳转授权中"，防止页面跳转后回来再次触发
			sessionStorage.setItem(WX_REDIRECTING_KEY, '1')
			try {
				// 清除旧用户信息
				try {
					const userStore = UserInfo()
					userStore.clearUserInfo()
				} catch (e) {
					localStorage.removeItem('User')
				}
				// 清除冷却期标志
				sessionStorage.removeItem(WX_AUTH_FAIL_AT_KEY)
				await handleWeChatAuth()
			} catch (e) {
				console.error('[request] 401 微信授权处理异常', e)
				// 授权异常时清除跳转标志，避免永久锁死
				sessionStorage.removeItem(WX_REDIRECTING_KEY)
			} finally {
				isHandling401 = false
			}
		}
		return Promise.reject(error)
	},
)

export default request



// WEBPACK FOOTER //
// ./src/utils/request.js